Controller = App.loadClass 'core::Angular/Controller'

class exports.ConservationPracticesController extends Controller
    constructor: (@scope, @transitions, @modal, @http, @service) ->
        super

        if(@service.fpcResult.irrigation_map and @service.fpcResult.irrigation_map.details.tail_water_recovery)
            if not @practiceIsSelected('Irrigation System, Tail Water Recovery', 'conservation_practices')
                @service.fpcResult.data['conservation_practices'].push 'Irrigation System, Tail Water Recovery'

    descriptionPurposeDialog: () =>
        @modal.open
            windowClass: 'large_dialog'
            templateUrl: 'backend/grower/fieldprint/description-purpose-dialog'
            controller: 'DialogController'

    toggleConservationPractice: (practice) =>
        if @practiceIsSelected(practice, 'conservation_practices')
            _.remove(@service.fpcResult.data.conservation_practices, (item) => return item is practice)
            return

        return @service.fpcResult.data.conservation_practices.push practice

    togglePractice: (practice, key) =>
        if @practiceIsSelected(practice, key)
            _.remove(@service.fpcResult.data[key], (item) => return item is practice)
            return

        return @service.fpcResult.data[key].push practice

    practiceIsSelected: (practice, key) =>
        return _.find(@service.fpcResult.data[key], (item) => return item is practice)
